import React from 'react'
import { Loader } from '@s4l/ds'
import { useS4LContext } from '@s4l/react-context'
import { BreakpointSizes, useBrowser } from '@s4l/utils/hooks/useBrowser'

function MapLoader() {
  const { i18n } = useS4LContext()

  const { activeBreakpoint } = useBrowser()

  const top = activeBreakpoint >= BreakpointSizes.L ? 'var(--space-16)' : 'var(--space-64)'

  return (
    <Loader
      text={i18n.formatMessage({ id: 'global.searching' })}
      position={{ top, left: '50%', transform: 'translate(-50%)' }}
    />
  )
}
MapLoader.displayName = 'MapLoader'
export default MapLoader
